import React, { Component } from 'react'
import { connect } from 'react-redux'
export const accessControl = permissionsRequired => WrappedComponent => {
    const SecuredControl = class extends Component {

        render () {
            // const { permissions } = this.props.permissions
            const { user } = this.props.authentication
            // const isAllow  = permissionsRequired.every(p => permissions.indexOf(p) >= 0)
            // console.log( user)
            //if (!isAllow) {
            if (user.type === 'CLIENTE') {
                return <div><i>No tiene permisos de acceso</i></div>
            }
            return <WrappedComponent { ...this.props }></WrappedComponent>
        }
    }
    return connect(state => ({ permissions: state.permissions, authentication: state.authentication }))(SecuredControl)
}